export const SORT_OPTIONS = [
  {
    value: "max_points",
    label: `Lowest Points`,
  },
  {
    value: "duration",
    label: `Quickest Flights`,
  },
  {
    value: "departure_time",
    label: `Lowest Tax`,
  },
  {
    value: "arrival_time",
    label: `Departure Time`,
  },
  {
    value: "tax",
    label: `Arrival Time`,
  },
  {
    value: "created_at",
    label: `Latest Seen`,
  },
];
